import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { DnevniPlanService } from './dnevni-plan.service';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-dnevni-plan',
  templateUrl: './dnevni-plan.component.html',
  styleUrls: ['./dnevni-plan.component.scss'],
  providers: [DnevniPlanService],
})
export class DnevniPlanComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  tablicaDnevniPlan: DxDataGridComponent;

  tablica: any;
  smjene: any;
  linije: any;
  o = moment().format('YYYY-MM-DD');
  d = moment().format('YYYY-MM-DD');
  s = '';
  l = '';
  promjenjenaSmjena = false;
  promjenjenaLinija = false;
  poruka = 'Učitavanje...';
  datumOd = moment();
  datumDo = moment();
  dodajPlanPopupVisible = false;
  obrisiPlanPopupVisible = false;
  nedostajuStavkePopup = false;
  nedostajuStavkeArray: any = [];
  sviProizvodi: any;
  odabraniProizvod: any;
  odabraniProizvodSifra: any;
  kolicina: any;
  noviDatum = moment();
  novaSmjena: any;
  novaLinija: any;
  linijePopup: any;
  smjenePopup: any;
  errorMessage: string;
  uredjivanje = false;
  naslov: string;
  idPlan: number;
  napomena: string;
  idBrisanje: any;
  partneri: any;
  odabraniPartner: any;
  postojiPolovicnaPaleta = false;
  polovicnePalete: any;
  nadopuni = false;
  nadopuniPlanId: number = null;
  maksimumOdabraneLinije = null;
  proizvodNaAkciji = false;
  djelatnici: any = [];
  tjedan: number;
  nedjelja = moment().day(0).format('YYYY-MM-DD');
  petak = moment().day(5).format('YYYY-MM-DD');
  odabraniDjelatnik: any;
  radnici = [];
  disabledDodaj: boolean = false;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: DnevniPlanService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.smjene = [
      { id: '', naziv: 'SVE' },
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];
    this.smjenePopup = [
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];
    this.linije = [{ id: '', naziv: 'SVE' }];
    this.linijePopup = [{ id: '', naziv: '' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().planProizvodnjePoDanima;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.tjedanUGodini(this.nedjelja, this.petak);
    this.dohvatiSveLinije();
    this.dohvatiSveProizvode();
    this.dohvatiPartnere();
    this.dnevniPlan(this.o, this.d, this.s, this.l);
  }

  dohvatiDjelatnike(tjedan: number, smjena: number, linija: number) {
    let data = {
      //dodano 12.01.2024. zbog problema s rasporedom ljudi jer je hvatalo i od ostalih godina a treba od trenutne
      godina: new Date().getFullYear(),
      tjedanugodini: tjedan,
      smjena: smjena,
      idlinija: linija,
    };
    //console.log(data);
    this.service.dohvatiDjelatnike(data).subscribe((res) => {
      //console.log(res);
      this.djelatnici = [];
      //this.djelatnici = res.data;
      for (let djelatnik of res.data) {
        this.djelatnici.push({
          name: djelatnik.ld_djelatnik,
          id: djelatnik.idlinijadjelatnik,
        });
      }
      //console.log(this.djelatnici);
    }).add(() => {
      this.dodajSveRadnike();
    });
  }

  tjedanUGodini(nedjelja, petak) {
    this.service.tjedanUGodini({ datumod: nedjelja, datumdo: petak }).subscribe((res) => {
      //console.log(res);
      this.tjedan = res.data[0].tjedanugodini;
      //console.log(this.tjedan);
    });
  }

  // Promjena datuma
  onValueChangedDatumOd(e) {
    //console.log(e);
    this.datumOd = e.value;
    this.o = moment(e.value).format('YYYY-MM-DD');
    //console.log(this.o + " " + this.d);
    this.dnevniPlan(this.o, this.d, this.s, this.l);
  }

  onValueChangedDatumDo(e) {
    //console.log(e);
    this.datumDo = e.value;
    this.d = moment(e.value).format('YYYY-MM-DD');
    //console.log(this.o + " " + this.d);
    this.dnevniPlan(this.o, this.d, this.s, this.l);
  }

  dnevniPlan(o, d, s, l) {
    let objekt = {
      datumod: o,
      datumdo: d,
      smjena: s,
      brojlinije: l,
    };
    //console.log(objekt);
    this.tablica = [];
    this.service.dnevniPlan(objekt).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema podataka!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let data of res.data) {
          this.tablica.push({
            datum: moment(data.pp_datumsmjena).format('DD.MM.YYYY.'),
            sifra: data.ar_sifra,
            naziv: data.ar_naziv,
            idProizvoda: data.artikl_ar_id,
            kolicina: data.pp_planiranakolicina,
            smjena: data.smjena_idsmjena,
            linijaBroj: data.pp_brojlinije,
            linijaNaziv: data.li_naziv,
            idPlan: data.idplanproizvodnje,
            napomena: data.pp_napomena,
            idRNalog: data.nl_id,
            idPartner: data.partner_idpartner,
            partner: data.pa_naziv,
            djelatnici: data.djelatnici,
          });
        }
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  promjenaSmjene(e) {
    //console.log(e);
    this.s = e.value;
    //this.nadzornaPloca(this.s, this.l);
    this.dnevniPlan(this.o, this.d, this.s, this.l);
  }

  promjenaLinije(e) {
    //console.log(e);
    this.l = e.value;
    //this.nadzornaPloca(this.s, this.l);
    this.dnevniPlan(this.o, this.d, this.s, this.l);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'before',
        template: 'naslovTablice',
      },
      {
        location: 'after',
        template: 'odabirLinije',
      },
      {
        location: 'after',
        template: 'odabirSmjene',
      }
    );
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "smjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }

  // DOHVAĆANJE NAZIVA LINIJA
  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      //console.log(res);
      this.linije = [{ id: '', naziv: 'SVE' }];
      this.linijePopup = [];
      if (res.success == true) {
        for (let linija of res.data) {
          //console.log(linija);
          this.linije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
          this.linijePopup.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
        }
        //console.log(this.linije);
        //console.log(this.linijePopup);
      }
    });
  }

  dodajPlanPopup() {
    //console.log(this.linije);
    this.dodajPlanPopupVisible = true;
    this.uredjivanje = false;
    this.naslov = 'Dodaj plan';
    this.errorMessage = '';
    this.odabraniProizvod = '';
    this.odabraniProizvodSifra = '';
    this.kolicina = '';
    this.novaSmjena = '';
    this.novaLinija = '';
    this.napomena = '';
    this.odabraniPartner = '';
    this.nadopuni = false;
    this.nadopuniPlanId = null;
    this.maksimumOdabraneLinije = null;
    this.noviDatum = moment();
    //this.nedjelja = moment(this.noviDatum).day(0).format('YYYY-MM-DD');
    //this.petak = moment(this.noviDatum).day(5).format('YYYY-MM-DD');
    //this.tjedanUGodini(this.nedjelja, this.petak);
    this.radnici = [];
  }

  onPopupClosed() {
    this.odabraniDjelatnik = undefined;
  }

  dohvatiSveProizvode() {
    this.service.dohvatiSveProizvode({}).subscribe((res) => {
      //console.log(res);
      this.sviProizvodi = [];
      //this.sviProizvodi = res.data;
      for (let data of res.data) {
        this.sviProizvodi.push({
          id: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          sifraNaziv: data.sifrainaziv,
        });
      }

      this.sviProizvodi = new DataSource({
        store: this.sviProizvodi
      });
      //console.log(this.sviProizvodi);
    });
  }

  dohvatiArtikleUCjenikuZaPartnera() {
    this.service.dohvatiArtikleUCjenikuZaPartnera({
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('user'),
      partner_pa_id: this.odabraniPartner
    }).subscribe((res) => {

      //console.log(res)
      this.sviProizvodi = [];
      //this.sviProizvodi = res.data;
      for (let data of res.data) {
        this.sviProizvodi.push({
          id: data.artikl_ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          sifraNaziv: data.sifrainaziv,
        });
      }
    })
  }

  dohvatiPartnere() {
    this.service.dohvatiPartnere({}).subscribe((res) => {
      //console.log(res);
      this.partneri = [];
      for (let data of res.data) {
        this.partneri.push({
          id: data.pa_id,
          sifra: data.pa_sifra,
          naziv: data.pa_naziv,
        });
      }

      this.partneri = new DataSource({
        store: this.partneri
      });
      //console.log(this.partneri);
    });
  }

  provjeraProizvodaNaAkciji(artikl, partner, datum) {
    this.proizvodNaAkciji = false;
    let data = {
      idartikl: artikl,
      idpartner: partner,
      datum: moment(datum).format('YYYY-MM-DD'),
    };
    //console.log(data);
    this.service.provjeraProizvodaNaAkciji(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true && res.data.length) {
        this.proizvodNaAkciji = true;
        //console.log(this.proizvodNaAkciji);
      } else {
        this.proizvodNaAkciji = false;
        //console.log(this.proizvodNaAkciji);
      }
    });
  }

  odaberiProizvod(e) {
    //console.log(e);
    this.odabraniProizvodSifra = e.component.option('selectedItem').sifra;
    //console.log(this.odabraniProizvodSifra);
    this.odabraniProizvod = e.value;
    if (this.odabraniProizvod && this.odabraniPartner && this.noviDatum) {
      this.provjeraProizvodaNaAkciji(
        this.odabraniProizvod,
        this.odabraniPartner,
        this.noviDatum
      );
    }
    if (e.event !== undefined) {
      //console.log('Postoji odabrani proizvod: ' + this.odabraniProizvod);
      this.linijePopup = [];
      // Provjera mogućih linija za proizvodnju odabranog proizvoda
      this.service.provjeraLinija({ idartikl: this.odabraniProizvod }).subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          for (let linija of res.data) {
            this.linijePopup.push({
              id: linija.kl_brojlinije,
              naziv: linija.li_naziv,
            });
          }
        }
      });
      // Provjera polovičnih paleta
      this.service.provjeraPaleta({ idartikl: this.odabraniProizvod }).subscribe((res) => {
        //console.log(res);
        if (res.data.length > 0) {
          this.postojiPolovicnaPaleta = true;
          this.polovicnePalete = [];
          for (let paleta of res.data) {
            this.polovicnePalete.push({
              idPlan: paleta.planproizvodnje_idplanproizvodnje,
              brojKartona: paleta.brojkartonanapolovicnojpaleti,
              maxKartona: paleta.brojkartonazajednupaletu,
              prikaz:
                'Plan: ' +
                paleta.planproizvodnje_idplanproizvodnje +
                ', Kartona: ' +
                paleta.brojkartonanapolovicnojpaleti +
                '/' +
                paleta.brojkartonazajednupaletu +
                ', Broj palete: ' +
                paleta.nd_rednibrojnalepnice,
            });
          }
        } else {
          this.postojiPolovicnaPaleta = false;
        }
      });
    } else {
      this.postojiPolovicnaPaleta = false;
      this.dohvatiSveLinije();
    }
  }

  nadopuniPaletu(e) {
    //console.log(e);
    this.nadopuni = e.value;
    if (this.nadopuni) {
      this.nadopuniPlanId = this.polovicnePalete[0].idPlan;
    } else {
      this.nadopuniPlanId = null;
    }
  }

  nadopuniPlan(e) {
    //console.log(e);
    this.nadopuniPlanId = e.value.idPlan;
  }

  odaberiPartnera(e) {
    console.log(e);
    this.odabraniPartner = e.value;
    //this.dohvatiArtikleUCjenikuZaPartnera();
    if (this.odabraniProizvod && this.odabraniPartner && this.noviDatum) {
      this.provjeraProizvodaNaAkciji(
        this.odabraniProizvod,
        this.odabraniPartner,
        this.noviDatum
      );
    }
  }

  odaberiKolicinu(e) {
    //console.log(e);
    if (e.value > this.maksimumOdabraneLinije) {
      this.kolicina = this.maksimumOdabraneLinije;
    }
    // else {
    this.kolicina = e.value;
    // }
  }

  onValueChangedDatum(e) {
    //console.log(e);
    this.noviDatum = e.value;
    this.nedjelja = moment(this.noviDatum).day(0).format('YYYY-MM-DD');
    this.petak = moment(this.noviDatum).day(5).format('YYYY-MM-DD');
    this.tjedanUGodini(this.nedjelja, this.petak);
    if (this.odabraniProizvod && this.odabraniPartner && this.noviDatum) {
      this.provjeraProizvodaNaAkciji(
        this.odabraniProizvod,
        this.odabraniPartner,
        this.noviDatum
      );
    }
    setTimeout(() => {
      // alert(`Api timeout: ${this.tjedan}`);
      this.dohvatiDjelatnike(this.tjedan, this.novaSmjena, this.novaLinija);
    }, 100);
  }

  dodajSveRadnike() {
    this.radnici = [];
    for (let radnik of this.djelatnici) {
      if (!this.provjeraPostojeciRadnik(radnik.name)) {
        this.radnici.push({
          djelatnici: radnik.name,
        });
      }
    }
  }

  odaberiDjelatnika(e) {
    //console.log(e);
    this.odabraniDjelatnik = e.value;
    if (this.odabraniDjelatnik != undefined) {
      if (!this.provjeraPostojeciRadnik(this.odabraniDjelatnik)) {
        this.radnici.push({
          djelatnici: this.odabraniDjelatnik,
        });
      } else {
        notify('Odabrani djelatnik je na popisu.', 'warning', 3000);
      }
    }
  }
  provjeraPostojeciRadnik(djelatnici) {
    return this.radnici.some(function (el) {
      return el.djelatnici === djelatnici;
    });
  }
  ukloniRadnika(index) {
    this.radnici.splice(index, 1);
  }

  onValueChangedSmjena(e) {
    //console.log(e);
    this.novaSmjena = e.value;
    //console.log(this.tjedan);
    //console.log(this.novaSmjena);
    this.dohvatiDjelatnike(this.tjedan, this.novaSmjena, this.novaLinija);
  }

  onValueChangedLinija(e) {
    //console.log(e);
    this.novaLinija = e.value;
    if (this.odabraniProizvod && this.novaLinija) {
      this.service.maksimumLinije({ idartikl: this.odabraniProizvod, idlinija: this.novaLinija }).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.maksimumOdabraneLinije = res.data[0].kl_maxkolicina;
        }
      });
    }
    this.dohvatiDjelatnike(this.tjedan, this.novaSmjena, this.novaLinija);
  }

  onValueChangedNapomena(e) {
    //console.log(e);
    this.napomena = e.value;
  }

  dodajPlan() {
    this.disabledDodaj = true;
    let podaci = {
      idartikl: this.odabraniProizvod,
      kolicina: this.kolicina,
      datum: moment(this.noviDatum).format('YYYY-MM-DD'),
      smjena: this.novaSmjena,
      linija: this.novaLinija,
      napomena: this.napomena,
      idpartner: this.odabraniPartner,
      idkorisnikzapisao: localStorage.getItem('user'),
      nadopuna: this.nadopuni === true ? 2 : 0,
      idplannadopuna: this.nadopuniPlanId,
      djelatnici: this.radnici,
      idfirma: localStorage.getItem('firma'),
      artiklsifra: this.odabraniProizvodSifra,
    };
    //console.log(podaci);
    if (
      this.odabraniProizvod == '' ||
      this.kolicina == '' ||
      this.novaSmjena == '' ||
      this.novaLinija == '' ||
      this.odabraniPartner == ''
    ) {
      this.disabledDodaj = false;
      this.errorMessage = 'Provjerite ispravnost podataka, sva polja moraju biti unešena!';
    } else {
      // OMOGUĆI SPREMANJE PLANA
      this.errorMessage = '';
      //console.log(podaci);
      this.service.dodavanjeBezNarudzbe(podaci).subscribe((res) => {
        //console.log(res);
        this.disabledDodaj = false;
        if (res.success === true) {
          this.dodajPlanPopupVisible = false;
          this.dnevniPlan(this.o, this.d, this.s, this.l);
          notify(res.message, 'success', 3000);
          
          if (res.data.length > 0) {
            this.nedostajuStavkePopup = true;
            this.nedostajuStavkeArray = res.data;
          }
        } else if (res.success === false) {
          let poruka = res.message;
          try {
            if (res.data[0][0].poruka) {
              poruka = res.data[0][0].poruka;
            } 
          }catch{
            
          }
          notify(poruka, 'error', 5000);
        } else {
          notify(res, 'warning', 3000);
        }
      });
    }
  }

  zatvoriPopup_nedostajuStavke(){
    this.nedostajuStavkePopup = false;
  }

  urediPlanPopup(data) {
    //console.log(data);
    this.uredjivanje = true;
    this.dodajPlanPopupVisible = true;
    this.naslov = 'Uredi plan';
    this.errorMessage = '';
    this.noviDatum = moment(data.data.datum, 'DD.MM.YYYY.');
    this.odabraniProizvod = data.data.idProizvoda;
    this.kolicina = data.data.kolicina;
    this.novaSmjena = data.data.smjena;
    this.novaLinija = data.data.linijaBroj;
    this.idPlan = data.data.idPlan;
    this.napomena = data.data.napomena;
    this.odabraniPartner = data.data.idPartner;
    this.nadopuni = false;
    this.nadopuniPlanId = null;
    this.radnici = [];
    let radnici =
      data.data.djelatnici != null ? data.data.djelatnici.split(',') : [];
    for (let radnik of radnici) {
      this.radnici.push({
        djelatnici: radnik,
      });
    }
  }

  urediPlan() {
    let podaci = {
      idartikl: this.odabraniProizvod,
      kolicina: this.kolicina,
      datum: moment(this.noviDatum).format('YYYY-MM-DD'),
      smjena: this.novaSmjena,
      linija: this.novaLinija,
      idplanproizvodnje: this.idPlan,
      napomena: this.napomena,
      idpartner: this.odabraniPartner,
      idkorisnikzapisao: localStorage.getItem('user'),
      nadopuna: this.nadopuni === true ? 2 : 0,
      idplannadopuna: this.nadopuniPlanId,
      djelatnici: this.radnici,
    };
    //console.log(podaci);
    if (
      this.odabraniProizvod == '' ||
      this.kolicina == '' ||
      this.novaSmjena == '' ||
      this.novaLinija == ''
    ) {
      this.errorMessage =
        'Provjerite ispravnost podataka, sva polja moraju biti unešena!';
    } else {
      this.errorMessage = '';
      //console.log(podaci);
      this.service.uredjivanjeBezNarudzbe(podaci).subscribe((res) => {
        //console.log(res);
        if (res.success == true) {
          this.dodajPlanPopupVisible = false;
          this.dnevniPlan(this.o, this.d, this.s, this.l);
          notify(res.message, 'success', 3000);

          if (res.data.length > 0) {
            this.nedostajuStavkePopup = true;
            this.nedostajuStavkeArray = res.data;
          }
        } else {
          notify(res.message, 'warning', 3000);
        }
      });
    }
  }

  brisanjePlanaPopup(data) {
    //console.log(data.data);
    this.obrisiPlanPopupVisible = true;
    //console.log(this.obrisiPlanPopupVisible);
    this.idBrisanje = data.data.idPlan;
  }

  obrisiPlan() {
    this.service.brisanjeBezNarudzbe({ idplanproizvodnje: this.idBrisanje }).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        this.obrisiPlanPopupVisible = false;
        this.dnevniPlan(this.o, this.d, this.s, this.l);
        notify('Uspješno obrisan plan.', 'success', 3000);
      }
    });
  }
}
